<template>
  <div class="prepaid-credit">
    <div class="credit-title">
      <i class="el-icon-document"></i>
      <span>充值金额记录</span>
    </div>

    <el-table
      :data="prepaidRecords"
      border
      stripe
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        width="60"
        align="center">
      </el-table-column>
      <el-table-column
        prop="iccid"
        label="ICCID"
        width="180"
        align="center">
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        width="270"
        align="center">
      </el-table-column>
      <el-table-column
        prop="chargeAmount"
        label="充值金额"
        width="100"
        align="center">
      </el-table-column>
      <el-table-column
        prop="giftAmount"
        label="赠送金额"
        width="100"
        align="center">
      </el-table-column>
      <el-table-column
        prop="payAmount"
        label="支付金额"
        width="100"
        align="center">
      </el-table-column>
      <el-table-column
        prop="payStatus"
        label="支付状态"
        width="100"
        align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.payStatus === '已支付' ? 'success' : 'info'" size="small">
            {{ scope.row.payStatus }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="refundUser"
        label="退款人"
        width="100"
        align="center">
      </el-table-column>
      <el-table-column
        prop="refundTime"
        label="退款时间"
        width="200"
        align="center">
      </el-table-column>
      <el-table-column
        prop="refundNote"
        label="退款备注"
        width="150"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createDateStr"
        label="创建时间"
        width="220"
        align="center">
      </el-table-column>
      <!-- <el-table-column
        fixed="right"
        label="操作"
        width="100"
        align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="handleRefund(scope.row)">
            用户充值
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'PrepaidCredit',
  props: {
    records: {
      type: Array,
      default: () => []
    },
    orderData: {
      type: Object,
      default: () => ({})
    },
  },
 
  data() {
    return {
      tableData: [{
        iccid: '',
        orderNo: '',
        chargeAmount: '',
        giftAmount: '',
        payAmount: '',
        payStatus: '',
        refundUser: '',
        refundTime: '',
        refundNote: '',
        createDateStr: ''
      }]
    }
  },
  computed: {
    prepaidRecords() {
      if (this.records && this.records.length > 0) {
        console.log('PrepaidCredit接收到的所有records:', this.records);
        
        // 根据截图中的数据结构，筛选充值记录
        // 根据截图，充值记录是op_money为100且record_source为5的记录
        const filteredRecords = this.records.filter(record => {
          console.log('检查记录:', record);
          // 检查是否为充值记录
          return (record.record_type === '增加' || 
                 (record.op_money === 100 && record.record_source === 5));
        });
        console.log('筛选后的充值记录:', filteredRecords);
        
        // 将API返回的数据格式转换为表格需要的格式
        return filteredRecords.map(record => {
          return {
            iccid: record.cardId || this.orderData.cardId || '',
            orderNo: this.orderData.orderNumber || '',
            chargeAmount: record.op_money || 0,
            giftAmount: this.orderData.giftMoney || 0,
            payAmount: record.op_money || 0,
            payStatus: '已支付',
            refundUser: '',
            refundTime: '',
            refundNote: '',
            createDateStr: this.orderData.createDateStr || record.create_date || ''
          };
        });
      }
      console.log('没有充值记录或records为空');
      return this.tableData;
    }
  },
  mounted() {
    console.log('PrepaidCredit组件挂载完成，records:', this.records);
    console.log('PrepaidCredit组件挂载完成，orderData:', this.orderData);
  },
  methods: {
    handleRefund(row) {
      console.log('充值操作', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.prepaid-credit {
  margin-top: 5px;
  background-color: #f3f5f7;
  border-radius: 4px;
  padding: 10px;
 

  .credit-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
    color: #606266;
   

    i {
      margin-right: 6px;
      font-size: 16px;
    }
  }

  .el-table {
    margin-bottom: 20px;
  }
}
</style>
